import * as React from "react";

/** Filled dot — same 20x20 grid as the star icons so slots align on one baseline */
export const IconDot = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="19" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="2.5" fill="currentColor" />
  </svg>
);
